import { useContext, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { axiosClient } from '../../../../library/Service/axiosClient';

function CounsellingLogs() {
    const { id, pageName } = useParams();

        const [usersessions, setUserSessions] = useState([]);
    
        useEffect(() => {
            if (!id) return;
        
            const fetchPreferenceData = async () => {
                try {
                    const response = await axiosClient().get(
                        `${process.env.REACT_APP_BAS_API}/counsellorsession/user-session/${id}`
                    );
    
                    const result = response.data?.data;
    
                    console.log(response.data, 'data at 24')
    
                    setUserSessions(response.data?.data || []);
    
                } catch (error) {
                    console.error("Error fetching preference data:", error);
                }
            };
    
            fetchPreferenceData();
        }, [id]);
    
        const formatDateTime = (dateStr: string) => {
            const date = new Date(dateStr);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
            const year = date.getFullYear();
            const time = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            
            return `${day}-${month}-${year} ${time}`;
        };

        const formatDate = (dateStr: string) => {
            const date = new Date(dateStr);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
            const year = date.getFullYear();
            const time = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            
            return `${day}-${month}-${year}`;
        };

          
        const formatTime = (dateStr: string) => {
            const date = new Date(dateStr);
            return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        };
    
    
  return (
    <>
    <div>
                <div className="counselling-lists">
                    <div className="tab-white-block mb-2 p-0 overflow-hidden border">
                        {/* {canEditProfile(model.id, sessionState) && (
                            <a className="pencil-edit" role="button" onClick={() => navigate(`/alumni/${id}/profile-picture`)}></a>
                        )} */}
                        <div className="d-flex flex-wrap flex-column flex-md-row">
                                            <div className="nav flex-row flex-md-column nav-pills custom-sub-tab ps-3 py-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                                <Link className="nav-link" to={`/alumni/${id}/profile/counselling`}>Psychometric Tests </Link>
                                                <Link className="nav-link" to={`/alumni/${id}/profile/sessions`}>Sessions</Link>
                                                <Link className="nav-link active" to={`/alumni/${id}/profile/counselling-logs`}>Counselling Logs</Link>
                                                <Link className="nav-link" to={`/alumni/${id}/profile/communication-logs`} >Communication Logs</Link>
                                                <Link className="nav-link" to={`/alumni/${id}/profile/counsellor-notes`} >Counsellor Notes</Link>   
                                            </div>
                                            <div className="tab-content p-3 p-sm-4 p-md-5 bg-gray-F2F4F7 width-cal-191" id="v-pills-tabContent">
                                         
                                                <div className="tab-pane fade fade active show" id="v-pills-counselling-logs" role="tabpanel" aria-labelledby="v-pills-counselling-logs-tab">
                                                    <div className='verticalScrol'>
        <div className="table-responsive attendee_dtl">
                   
                   <table className="table lite-blue-header" style={{minWidth: 845}}>
                       <thead>
                           <tr>
                               <th>Updated on</th>
                               <th>Updated by</th>
                               <th>Details</th>
                               <th >Comment</th>
                              
                           </tr>
                       </thead>
                       <tbody>
                           {/* <tr>
                               <td>10-Apr-2024</td>
                               <td>Ayushi Vasudev</td>
                               <td width={200}>Marked "Student as Primary"contact</td>
                               <td width={280}><div>After counselling session the
                               parent only suggested that</div>
                               <a href="#" className='text-green'>Read More</a></td>                            
                           </tr> */}
                           {usersessions.map((userdata: any, index: number) => {
                                const fullName = `${userdata.first_name || ''} ${userdata.last_name || ''}`.trim() || 'Unknown Counsellor';
                                
                                
                                    
                                    
                                    const updatedAt = userdata.updated_at
                                    ? formatDate(userdata.updated_at)
                                    : formatDate(userdata.created_by);
                                    
                                    // const createdBy = userdata.created_by
                                    // ? formatDate(userdata.created_by)
                                    // : 'N/A';
                                    


                                return (
                                <tr>
                                <td>{updatedAt}</td>
                                <td>{fullName}</td>
                                <td width={200}>{`CS${userdata.counselling_stage}`} - {userdata.is_rescheduled === 1 ? 'RE-SCHEDULED' : userdata.counselling_status}
                                </td>
                                <td width={280}> </td>                            
                            </tr>
                                );
                            })}

                           

                           {/* <tr>
                               <td>02-Apr-2024</td>
                               <td>Esther Rani</td>
                               <td width={200}>CS1 Booked from internal admin</td>
                               <td width={280}>
                              <div>Session Booked after call
                              confirmation from parent</div>
                                <a href="#" className='text-green'>Read More</a> 
                               </td>                            
                           </tr>

                           <tr>
                               <td>31-Jan-2024</td>
                               <td>Esther Rani</td>
                               <td width={200}>Counsellor updated from "NA" to "Ayushi Vasudev"</td>
                               <td width={280}> </td>                            
                           </tr> */}

                    

                        
                          

                       </tbody>
                   </table>

               </div>
        </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                    </div>
                    
    
                    
    
                </div>
            </div>
        
    </>
  )
}

export default CounsellingLogs;